import React, {useContext} from 'react';
import ScrollMenu from "react-horizontal-scrolling-menu";
import style from "./category.module.css";
import {Data} from './CategoryData';
import CountUp from "react-countup";
import logo from '../../../assets/dashboard/logoCardBack.svg';
import {Store} from "../../../Store";
import {useTranslation} from "react-i18next";

export default function Dashboard() {
   const {state, dispatch} = useContext(Store);
   const {t} = useTranslation()
   const states = {
      dragging: true,
      scrollBy: 2,
      arrowLeft: false,
      arrowRight: false,
      alignCenter: false
   }

   return (
      <div className={style.scroll}>
         <ScrollMenu
            {...states}
            data={Data.map((el, i) =>
               <div className={style[state.mode]} key={i}>
                  <img src={logo} alt="" className={style.back}/>
                  <div>
                     <h1><CountUp end={el.amount} duration={5}/></h1>
                     <h2>{t(`${el.name}`)}</h2>
                  </div>
                  <img src={el.img} alt=""/>
               </div>
            )}
         />
      </div>
   )
}